var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMonday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.653 24.9996C4.0003 24.9985 3.35977 24.8029 2.7978 24.4331C2.23584 24.0634 1.77292 23.5329 1.45703 22.8967C1.14115 22.2606 0.983805 21.5419 1.00132 20.8152C1.01883 20.0885 1.21056 19.3803 1.55663 18.7639L8.13887 7.05624C8.65377 6.14049 9.4742 5.49006 10.4197 5.24804C10.8878 5.12821 11.3726 5.11225 11.8463 5.20107C12.32 5.28989 12.7733 5.48176 13.1804 5.76572C13.5876 6.04968 13.9405 6.42017 14.219 6.85604C14.4976 7.2919 14.6963 7.78461 14.8039 8.30602C14.9115 8.82744 14.9259 9.36735 14.8461 9.89494C14.7664 10.4225 14.5941 10.9274 14.3391 11.3809L7.75539 23.0885C7.42639 23.6741 6.96897 24.1568 6.42622 24.4912C5.88347 24.8255 5.27324 25.0005 4.653 24.9996Z",
    fill: "#FF3D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9969 25C15.3437 25 14.7024 24.8053 14.1396 24.436C13.5768 24.0668 13.113 23.5364 12.7964 22.9001C12.4798 22.2637 12.3219 21.5445 12.3392 20.8173C12.3564 20.09 12.5482 19.3811 12.8945 18.7643L19.4813 7.05662C19.7255 6.5793 20.0539 6.16193 20.4467 5.82962C20.8395 5.49732 21.2886 5.25695 21.767 5.12297C22.2453 4.989 22.7431 4.96419 23.2303 5.05004C23.7175 5.13588 24.1841 5.33061 24.602 5.62251C25.0199 5.91441 25.3804 6.29744 25.662 6.74856C25.9435 7.19968 26.1402 7.70957 26.2402 8.24755C26.3402 8.78553 26.3415 9.34049 26.2439 9.87902C26.1463 10.4176 25.952 10.9286 25.6725 11.3813L19.0978 23.0889C18.7688 23.6745 18.3114 24.1572 17.7686 24.4916C17.2259 24.8259 16.6171 25.0009 15.9969 25Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3362 24.9969C29.3594 24.9969 30.9995 23.2159 30.9995 21.0189C30.9995 18.822 29.3594 17.041 27.3362 17.041C25.313 17.041 23.6729 18.822 23.6729 21.0189C23.6729 23.2159 25.313 24.9969 27.3362 24.9969Z",
    fill: "#00D647"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMonday);
export default __webpack_public_path__ + "static/media/HeaderMonday.922fdef7e5e6d3b7eb83de62820fc0ac.svg";
export { ForwardRef as ReactComponent };